import { Link } from 'react-router-dom';

import { AccountMenu } from '@/components/AccountMenu';
import { BrandLogo } from '@/components/BrandLogo';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { signInWithBackend } from '@/services';
import { cn } from '@/services/utils';

// Mobile counterpart to AppTopHeader, shown on every app route. Navigation lives in MobileTabBar
// instead, and each page already owns its own inline search (Meaning's sticky search section,
// Videos' in-body search), so this stays to just brand + account — no in-bar search to keep in
// sync with the page.
export function MobileAppTopBar({ className }: { className?: string }) {
  const { isAuthenticated } = useAuth();

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex h-14 shrink-0 items-center justify-between border-b border-[#ece9e2] bg-white px-4 font-[family-name:var(--font-meaning-sans)]',
        className
      )}
    >
      <Link to="/meaning" aria-label="Yawca home" className="flex items-center">
        <BrandLogo compact markClassName="size-8" />
      </Link>

      {isAuthenticated ? (
        <AccountMenu />
      ) : (
        <Button size="sm" onClick={() => signInWithBackend()}>
          Sign in
        </Button>
      )}
    </header>
  );
}
